import React, { FC, ReactElement } from 'react';
import { useUtils } from 'utils/useUtils';
import Image from 'next/image';

export type Post = {
  id: number;
  image: any;
  date: string;
  title: string;
  url: string;
  likes?: number;
  views?: number;
  tag?: string;
};

type PostItemProps = {
  image: any;
  date: string;
  title: string;
  url: string;
};

const PostItem: FC<PostItemProps> = ({ image, date, title, url }: PostItemProps): ReactElement => {
  const { convertDate } = useUtils();
  const formattedDate = convertDate(date);

  return (
    <div className="freight-dictionary__post-item">
      <a className="freight-dictionary__post-item-link" href={url}>
        <div className="freight-dictionary__post-item-image-box">
          {image && <Image src={image} alt="post image" width={337} height={200} />}
        </div>
        <div className="freight-dictionary__post-item-content-box">
          <p className="freight-dictionary__post-item-date">{formattedDate}</p>
          <h4 className="freight-dictionary__post-item-title">{title}</h4>
        </div>
      </a>
    </div>
  );
};

export default PostItem;
